'use client';

import React from 'react';

import { submitLeadChurchForm } from '@sola/skippy-sdk/requests.js';

import { LeadForm } from '../../../organisms/forms/lead-form/lead-form';

export const SmallChurchLeadForm: React.FC = () => {
  // TODO: Probabaly need some direction on how we want to handle the success state - currently a generic thank you at the moment
  return (
    <section className="component component--no-header">
      <div className="container">
        <LeadForm
          onSubmit={submitLeadChurchForm('contactme', 'SmallChurchContactForm')}
          config={{
            phone: { hide: false, required: false },
            role: { hide: false, required: true },
            hasChurch: true,
            website: { hide: true, required: false },
            consent: false,
          }}
        />
      </div>
    </section>
  );
};
